module.exports = __webpack_public_path__ + "5928-shadow.bdb839f12fb5e35a1df4e86c268e3b3e.cache.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/anim/5928-shadow.png
// module id = 488
// module chunks = 0